<template>
  <div>
    <FormJobs></FormJobs>
  </div>
</template>

<script>
import FormJobs from "../components/FormJobs";

export default {
  name: "Content",
  components: {
    FormJobs,
  },
};
</script>
